__turbopack_context__.v({
  "arrow": "style-module-scss-module__MoXNvq__arrow",
  "menuLink": "style-module-scss-module__MoXNvq__menuLink",
});
